module.exports = __webpack_public_path__ + "img/service-icon-3.22656e49.png";